import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { golf } from './enums';

export function RewardsPoints({ rewardPoints }) {
  if (typeof rewardPoints !== 'number') {
    return null;
  }

  return (
    <div id='user-details-reward-points' className='reward-points'>
      <FormattedMessage
        id={ golf.proRewardPoints }
        values={{
          points: rewardPoints
        }}
      />
    </div>
  );
}

RewardsPoints.propTypes = {
  rewardPoints: PropTypes.number
};

export default RewardsPoints;
